import React, { useEffect, useState } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../assets/css/main.css';
import { Link } from 'react-router-dom';
import PricingModal from "./PricingModal";


const Pricing = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const openModal = (content) => {
        setModalContent(content);
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
    };

    const plans = [
        {
            name: "Application Form Assistance Subscription",
            price: "5,000",
            period: "one time + 18% GST",
            description: "Our Application Assistance Service ensures a smooth and stress-free experience by guiding you through every step.",
            features: [
                { title: "One Subscription = One Applicant", explanation: "Each subscription is valid for one applicant only." },
                { title: "Comprehensive Application Assistance", explanation: "Get end-to-end support for filling out all suitable entrance and college admission applications. We ensure that every detail is accurately filled, reducing errors and stress." },
                { title: "Timely Updates", explanation: "Stay informed with regular updates on application deadlines and notifications regarding the opening and closing dates for forms related to your specific course." },
            ],
        },
        {
            name: "Career Counseling & Admission Assistance",
            price: "10,000",
            period: "one-time + 18% GST",
            description: "Comprehensive career counseling and admission guidance to help students achieve their academic and career goals.",
            features: [
                { title: "Basic Counseling Session", explanation: "A one-on-one counseling session with a Senior Career Counselor to discuss the student's academic goals, interests, and career aspirations." },
                { title: "Expert Career Guidance", explanation: "A dedicated Career Counselor will be assigned based on the student's chosen domain or course of interest. The counselor will provide expert advice and guidance throughout the process." },
                { title: "Student Profile Creation", explanation: "A personalized student profile will be created based on their academic merit, interests, and future goals." },
                { title: "Personalized Admission Pathway", explanation: "The counselor will offer a transparent overview of all available options based on the student’s profile and guide them towards securing a seat in the chosen college or institution." },
                { title: "Includes All Services from Subscription - 1", explanation: "Subscription - 2 includes all the services provided in Subscription - 1, including application form assistance and college admission support." },
            ],
        },
        {
            name: "Direct Admission Assistance",
            price: "25,000",
            period: "one-time + 18% GST",
            description: "Comprehensive assistance for direct admission under the Management Quota, including college visit support and scholarships.",
            features: [
                { title: "Management Quota Admission", explanation: "Subscription - 3 is primarily applicable for admission under the Management Quota in various colleges." },
                { title: "Scholarships & Fee Concessions", explanation: "We provide scholarships or concessions on college tuition fees and donations, helping you save on educational costs." },
                {
                    title: "College Visit Assistance",
                    explanation: "A dedicated representative will assist with your college visit, including a comprehensive campus tour and a meeting with the admission department."
                },
                {
                    title: "Additional Services",
                    explanation: "Includes transport (pickup and drop-off service) and a local language guide during the visit."
                },
                { title: "All Services from Subscription - 1 & 2 Included", explanation: "Subscription - 3 includes all the services provided in Subscription - 1 and Subscription - 2, such as application form assistance and career counseling." },
            ],
        },
        {
            name: "Prime Membership",
            price: "1,00,000 (For Engineering & MBA Courses), 2,00,000 (For Medical Courses)",
            period: "one-time + 18% GST",
            description: "Exclusive membership offering a comprehensive support package for students in Engineering, MBA, and Medical courses.",
            features: [
                { title: "Comprehensive Service Package", explanation: "Prime Membership includes access to all services provided by our firm, ensuring a seamless and comprehensive support system for your educational journey." },
                { title: "Lifetime Validity", explanation: "Enjoy lifetime validity for the membership, providing you with continuous support throughout your academic career." },
                { title: "Exclusive Access to Top Colleges", explanation: "This membership opens doors to the top Engineering, Medical, and MBA colleges, helping you secure admission to the best institutions with ease." },
            ],
        },
        // Additional plans...
    ];



    return (
        <section id="pricing" className="pricing section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Pricing</h2>
                <p>Explore our tailored career guidance plans for a variety of courses and degrees in India.</p>
            </div>

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row g-4 justify-content-center">
                    {plans.map((plan, index) => (
                        <div
                            className={`col-lg-4 ${plan.popular ? 'popular' : ''}`}
                            key={index}
                            data-aos="fade-up"
                            data-aos-delay={`${(index + 1) * 100}`}
                        >
                            <div className={`pricing-card border ${plan.popular ? 'popular' : ''}`}>
                                {plan.popular && <div className="popular-badge">Most Popular</div>}
                                <h3>{plan.name}</h3>
                                <div className="price text-center bg-light border p-3 rounded">
                                    <span className="currency">₹</span>
                                    <span className="amount">{plan.price}</span>
                                    <span className="period">/ {plan.period}</span>
                                </div>
                                <p className="description">{plan.description}</p>

                                <h4>Features Included:</h4>
                                <ul className="features-list">
                                    {plan.features.map((feature, i) => (
                                        <li key={i}>
                                            {feature.title}
                                            <span
                                                className="pricing-modal-icon"
                                                onClick={() => openModal(feature.explanation)}
                                            >
                                                <i className="bi bi-question-circle-fill"></i>
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                                <Link to="/payments" className={`btn ${plan.popular ? 'btn-light' : 'btn-primary'}`}>
                                    Buy Now
                                    <i className="bi bi-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <PricingModal show={modalVisible} onClose={closeModal} content={modalContent} />
        </section>
    );
};

export default Pricing;


